import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "horizontal-wizard-wrapper vertical-options vertical-variations" }
const _hoisted_2 = { class: "row g-3" }
const _hoisted_3 = { class: "col-xl-9" }
const _hoisted_4 = {
  class: "tab-content dark-field",
  id: "vertical-n-wizard-tabContent"
}

import { ref, defineAsyncComponent, onMounted, watchEffect, watch } from "vue";
import * as bootstrap from "bootstrap";
import apiService from "@/services/apiService";
import { toast } from "vue3-toastify";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'createWorkspaceModule',
  setup(__props) {

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);
const basicInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/moduleInfo.vue")
);
const sheetInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/sheetInfo.vue")
);
const cardListInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/cardListInfo.vue")
);
const cardVariable = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/cardVariable.vue")
);
const cardInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/cardInfo.vue")
);

const moduleId = ref();
const route = useRoute();

// set initial value
moduleId.value = route.params.moduleId as string | undefined;

// watch for changes
watch(
  () => route.params.moduleId,
  (newVal) => {
    moduleId.value = newVal as string | undefined;
  },
  { immediate: true } // also runs once on mount
);


function switchToTab(identifier: string | number): boolean {
  let tabLink: HTMLElement | null = null;

  if (typeof identifier === "string") {
    // Switch by tab ID
    tabLink = document.querySelector(`#${identifier}`) as HTMLElement;
  } else if (typeof identifier === "number") {
    // Switch by tab index (0-based)
    const tabLinks = document.querySelectorAll(
      "#vertical-n-wizard-tab .nav-link"
    );
    tabLink = tabLinks[identifier] as HTMLElement;
  }

  if (tabLink && typeof bootstrap !== "undefined" && bootstrap.Tab) {
    try {
      const tab = new bootstrap.Tab(tabLink);
      tab.show();
      return true;
    } catch (error) {
      console.error("Failed to switch tab:", error);
      return false;
    }
  } else {
    console.error(
      `Tab not found or Bootstrap Tab API unavailable. Identifier: ${identifier}`
    );
    return false;
  }
}

async function handleAddModule(data: { description: string }) {
  try {
    // Ensure is_default is always set to true
    const payload = {
      ...data,
      is_default: true
    };
    
    const response = await apiService.post("common/workspace-modules", payload);
    if (response) {
      moduleId.value = response?._id;
      toast.success("module added successfully");
      switchToTab("bank-n-wizard-tab");
    }
  } catch (error) {
    console.error("Error creating module:", error);
    toast.error("Failed to create module");
  }
}

function handleChangeSetup(data: {}) {
  console.log("Received from child:", data);
  switchToTab("inquiry-n-wizard-tab");
}
function handleCardListInfo(data: {}) {
  console.log("Received from child:", data);
  switchToTab("user-managment-n-wizard-tab");
}
function handleCardInfo(data: {}) {
  console.log("Received from child:", data);
  switchToTab("successful-n-wizard-tab");
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, { title: "pageTitle" }),
    _createVNode(_unref(Card1), {
      colClass: "col-sm-12",
      cardhaderClass: "pb-0 title-header",
      title: "Create Workspace Module"
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-xl-3 main-horizontal-header" }, [
              _createElementVNode("div", {
                class: "nav nav-pills horizontal-options",
                id: "vertical-n-wizard-tab",
                role: "tablist",
                "aria-orientation": "vertical"
              }, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  id: "wizard-n-info-tab",
                  "data-bs-toggle": "pill",
                  href: "#wizard-n-info",
                  role: "tab",
                  "aria-controls": "wizard-n-info",
                  "aria-selected": "true"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "1")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Module")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "bank-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#bank-n-wizard",
                  role: "tab",
                  "aria-controls": "bank-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "2")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Sheet ")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "user-managment-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#user-managment-n-wizard",
                  role: "tab",
                  "aria-controls": "user-managment-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "4")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Card")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "successful-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#successful-n-wizard",
                  role: "tab",
                  "aria-controls": "successful-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "5")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Card Variables")
                    ])
                  ])
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(basicInfo), { onContinue: handleAddModule }),
                _createVNode(_unref(sheetInfo), {
                  onContinue: handleChangeSetup,
                  moduleId: moduleId.value
                }, null, 8, ["moduleId"]),
                _createVNode(_unref(cardInfo), {
                  onContinue: handleCardInfo,
                  moduleId: moduleId.value
                }, null, 8, ["moduleId"]),
                _createVNode(_unref(cardVariable), { moduleId: moduleId.value }, null, 8, ["moduleId"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})